import { Player } from '@lottiefiles/react-lottie-player';

import LoaderLottieJSON from './../../../assets/lotties/loading-lottie.json';

function LottieLoader() {
  return (
    <Player
      autoplay
      loop
      src={LoaderLottieJSON}
      style={{ height: '200px', width: '200px' }}
    >
    </Player>
  )
}

export default LottieLoader